<article class="tile" [class.tile-pinned]="pinned">
  <div class="picture" role="button" tabindex="0" [attr.aria-label]="'نمای بزرگ تصویر ' + image.name"
    (click)="zoom.emit()" (keydown.enter)="zoom.emit()" (keydown.space)="$event.preventDefault(); zoom.emit()">
    <img *ngIf="!imageFailed" [src]="imageSrc" [alt]="'تصویر ' + image.name" loading="lazy" (error)="onImageError()">
    <span class="category">{{ image.category === 'cabin' ? 'کابین' : 'بیرون' }}</span>
    <span *ngIf="imageFailed" class="placeholder">تصویر در دسترس نیست</span>
  </div>
  <div class="tile-body">
    <div class="tile-heading">
      <strong class="name" [title]="image.name">{{ image.name }}</strong>
      <span class="freshness" [class.fresh]="status === 'تازه'" [class.delayed]="status === 'تأخیردار'" [class.old]="status === 'قدیمی'">{{ status }}</span>
    </div>
    <div class="meta">
      <span [title]="image.date">{{ ageLabel }}</span>
      <span>{{ image.speed == null || image.speed === '' ? 'سرعت نامشخص' : (image.speed | faNum) + ' km/h' }}</span>
    </div>
    <div class="tile-actions">
      <button type="button" [attr.aria-label]="pinned ? 'حذف پین' : 'پین کردن'" [attr.aria-pressed]="pinned" (click)="pin.emit()"><i class="fa fa-thumb-tack" aria-hidden="true"></i> {{ pinned ? 'حذف پین' : 'پین' }}</button>
      <button type="button" aria-label="نمای بزرگ" (click)="zoom.emit()"><i class="fa fa-expand" aria-hidden="true"></i> بزرگ</button>
      <a [routerLink]="['/surveillance', image.unitId]" target="_blank" rel="noopener" aria-label="نمایش دوربین"><i class="fa fa-camera" aria-hidden="true"></i> دوربین</a>
      <a [routerLink]="['/carInfo', image.unitId]" target="_blank" rel="noopener" aria-label="مشخصات خودرو"><i class="fa fa-external-link" aria-hidden="true"></i> خودرو</a>
    </div>
  </div>
</article>
